import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/ssid",

        async getAll(){
            return await Vue.http.get(this.url());
        },


        async create(payload) {
            return await Vue.http.post(this.url(), payload);
        },

        async update({ id, name }) {
            return await Vue.http.put(this.url(`/${id}`), { name });
        },

        async delete(id){
            return await Vue.http.delete(this.url(`/${id}`));
        }
    },
    base
);
